<template>
  <main id="main">
    <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height: 100vh;">
      <p>{{ t('loading') }}</p>
    </div>
    <div v-else>
      <div class="bg_gradient_theme_to_right p-4 rounded_header position-sticky top-0">
        <div class="d-flex align-items-center mb-5">
          <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
          <p id="title_header_page">{{ t('user_area') }}</p>
        </div>

        <div class="d-flex align-items-center justify-content-between gap-2">
          
          <img 
            :src="userInfo.pic" 
            class="rounded-pill shadow profile" 
            alt="" 
            @error="$event.target.src = require('@/assets/imgs/NoPath - Copy.svg')"
          >

          <div class="d-flex flex-column justify-content-center align-items-start gap-2 w-50">
            <p class="font_normal bold text-truncate">{{ userInfo.name }} {{ userInfo.family }}</p>
            <p class="font_small text-truncate" style="direction: ltr;">{{ userInfo.email }}</p>
            <p class="font_normal bold">{{ userInfo.user_code }}</p>
          </div>

          <div class="w-30 d-flex flex-column align-items-center justify-content-around gap-3">
            <button @click="showLogoutModal = true" class="w-100 py-2 bg_orange rounded-pill gap-1 d-flex align-items-center justify-content-center shadow_button">
              <img src="@/assets/imgs/logout.svg" class="icon-size-1" alt="">
              <span class="text-white font_small text-nowrap">{{ t('logout') }}</span>
            </button>
            <button @click="shareApp" class="w-100 py-2 bg_gradient_theme_to_bottom rounded-pill gap-1 d-flex align-items-center justify-content-center shadow_button">
              <img src="@/assets/imgs/share_white.svg" class="icon-size-1" alt="">
              <span class="text-white font_small text-nowrap">{{ t('app_intro') }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="p-4 pb-8">
        <div @click="showLangModal = true" class="d-flex align-items-center justify-content-between bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer">
          <div class="d-flex align-items-center gap-3">
            <img src="@/assets/imgs/translate_1.svg" class="icon-size-3" alt="">
            <p class="font_normal bold bold">{{ t('change_lang') }}</p>
          </div>
          <div class="d-flex align-items-center gap-2">
            <p class="font_small text_color_gray">{{ currentLanguageText }}</p>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-between bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="$router.push({ name: 'EditProfile' })">
          <div class="d-flex align-items-center gap-3">
             <img src="@/assets/imgs/person.svg" class="icon-size-3" alt="">
             <p class="font_normal">{{ t('edit_profile') }}</p>
          </div>
        </div>
        
        <div class="d-flex align-items-center justify-content-between bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="$router.push({ name: 'LessonsProgress' })">
          <div class="d-flex align-items-center gap-3">
             <img src="@/assets/imgs/layers.svg" class="icon-size-3" alt="">
             <p class="font_normal">{{ t('lesson_topics') }}</p>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-between bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="$router.push({ name: 'Exams' })">
          <div class="d-flex align-items-center gap-3">
             <img src="@/assets/imgs/newspaper.svg" class="icon-size-3" alt="">
             <p class="font_normal">{{ t('exams') }}</p>
          </div>
        </div>

        <div class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="$router.push({ name: 'UserQuestions' })">
          <img src="@/assets/imgs/blog_theme.svg" class="icon-size-3" alt="">
          <p class="font_normal">{{ t('qa_lessons') }}</p>
        </div>

        <div class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="$router.push({ name: 'ChartLessonsList' })">
          <img src="@/assets/imgs/increase.svg" class="icon-size-3" alt="">
          <p class="font_normal">{{ t('chart_lessons') }}</p>
        </div>

        <div class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="$router.push({ name: 'Certificate' })">
          <img src="@/assets/imgs/certificate.svg" class="icon-size-3" alt="">
          <p class="font_normal">{{ t('certificate') }}</p>
        </div>
        
        <div class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="showNextGradeModal = true">
          <img src="@/assets/imgs/clipboard_theme.svg" class="icon-size-3" alt="">
          <p class="font_normal">{{ t('register_next_grade') }}</p>
        </div>

        <div class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="goToInfoPage('about_us')">
          <img src="@/assets/imgs/information (2).svg" class="icon-size-3" alt="">
          <p class="font_normal">{{ t('about_us') }}</p>
        </div>

        <div class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="goToInfoPage('rules')">
          <img src="@/assets/imgs/newspaper.svg" class="icon-size-3" alt="">
          <p class="font_normal">{{ t('terms_conditions') }}</p>
        </div>

        <div class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-5 cursor-pointer" @click="$router.push({ name: 'Contact' })">
          <img src="@/assets/imgs/support.svg" class="icon-size-3" alt="">
          <p class="font_normal">{{ t('contact_us') }}</p>
        </div>
      </div>
      <BottomNav />
    </div>

    <div v-if="showLangModal" class="modal_overlay" @click.self="showLangModal = false">
      <div class="modal_content">
        <p class="text-center font_large bold mb-4">{{ t('select_lang') }}</p>
        <div class="d-flex flex-column gap-3 w-100">
          <button class="lang_button" @click="changeLanguage('dr')" :disabled="changingLanguage">
            {{ t('persian_dari') }}
          </button>
          <button class="lang_button" @click="changeLanguage('ps')" :disabled="changingLanguage">
            {{ t('pashto') }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="showLogoutModal" class="modal_overlay" @click.self="showLogoutModal = false">
      <div class="modal_content bg_white rounded-4 p-4 shadow_box text-center" style="max-width: 320px;">
        <p class="bold font_medium mb-4">آیا مطمئن هستید میخواهید از اکانت خود خارج شوید؟</p>
        <div class="d-flex gap-3">
          <button class="button w-100 bg_red" @click="confirmLogout">{{ t('yes') }}</button>
          <button class="button w-100 bg_gray" @click="showLogoutModal = false">{{ t('no') }}</button>
        </div>
      </div>
    </div>

    <div v-if="showNextGradeModal" class="modal_overlay" @click.self="showNextGradeModal = false">
      <div class="modal_content bg_white rounded-4 p-4 shadow_box text-center">
        <p class="bold font_medium mb-3">{{ t('next_grade_confirm_title') }}</p>
        <p class="font_small text_color_gray mb-4" style="line-height: 1.8;">{{ t('next_grade_confirm_desc') }}</p>
        <div class="d-flex gap-3">
          <button class="button w-100" @click="registerNextGrade" :disabled="registeringNextGrade">{{ registeringNextGrade ? t('loading') : t('yes_sure') }}</button>
          <button class="button w-100 bg_red" @click="showNextGradeModal = false" :disabled="registeringNextGrade">{{ t('cancel') }}</button>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import BottomNav from '@/components/BottomNav.vue'
import apiClient, { createFormData } from '@/services/api'
import { Decryption } from '@/utils/crypto'

export default {
  name: 'UserProfileView',
  components: {
    BottomNav
  },
  data() {
    return {
      userInfo: {
        name: '',
        family: '',
        email: '',
        user_code: '',
        pic: require('@/assets/imgs/NoPath - Copy.svg'),
        grade_id: null
      },
      loading: true,
      showLangModal: false,
      changingLanguage: false,
      showLogoutModal: false,
      showNextGradeModal: false,
      registeringNextGrade: false
    }
  },
  computed: {
    currentLanguage() {
      return localStorage.getItem('app_lang') || 'fa';
    },
    currentLanguageText() {
      const lang = this.currentLanguage;
      if (lang === 'ps') return this.t('pashto');
      return this.t('persian_dari');
    }
  },
  mounted() {
    this.fetchUserProfile();
  },
  methods: {
    async fetchUserProfile() {
      this.loading = true;
      try {
        const userId = localStorage.getItem('user_id');
        if (!userId) {
          this.$router.push({ name: 'Login' });
          return;
        }

        const formData = createFormData({
          action: 'user_info',
          user_id: userId
        });
        const response = await apiClient.post('/public_info', formData);
        
        let serverData = {};
        if (response.data.status === true && response.data.data) {
          serverData = Decryption(response.data.data);
        } else if (response.data.data) {
          serverData = response.data.data;
        } else if (response.data.id) {
          serverData = response.data;
        }

        this.userInfo.name = serverData.name || '';
        this.userInfo.family = serverData.family || '';
        this.userInfo.email = serverData.email || localStorage.getItem('user_email') || '';
        this.userInfo.user_code = serverData.user_code || serverData.ref_code || '';
        this.userInfo.grade_id = serverData.grade_id;

        let serverPic = serverData.pic;
        const localPic = localStorage.getItem('temp_profile_pic');
        const imageBaseUrl = 'https://back.ayendaman.org/storage/app/public/uploads/';

        if ((!serverPic || serverPic === 'nopic.png' || serverPic.includes('nopic') || serverPic === '') && localPic) {
           this.userInfo.pic = localPic;
        } else if (serverPic) {
           if (serverPic.startsWith('http')) {
             this.userInfo.pic = serverPic;
           } else {
             this.userInfo.pic = imageBaseUrl + serverPic;
           }
        }

      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        this.loading = false;
      }
    },
    confirmLogout() {
      localStorage.clear();
      this.$router.replace({ name: 'Language' });
    },
    goToInfoPage(pageType) {
      this.$router.push({ name: 'Info', params: { pageType: pageType } });
    },
    async changeLanguage(newLang) {
      this.changingLanguage = true;
      try {
        const userId = localStorage.getItem('user_id');
        const formData = createFormData({
          user_id: userId,
          new_lang: newLang
        });
        const response = await apiClient.post('/change_language', formData);
        if (response.data.status === 'ok') {
          const appLang = newLang === 'dr' ? 'fa' : newLang;
          localStorage.setItem('app_lang', appLang);
          this.showLangModal = false;
          alert(response.data.message);
          window.location.reload();
        } else {
          alert('مشکل در تغییر زبان');
        }
      } catch (error) {
        console.error("Error changing language:", error);
        alert('مشکل در ارتباط با سرور');
      } finally {
        this.changingLanguage = false;
      }
    },
    async shareApp() {
        const code = this.userInfo.user_code || '';
        const appUrl = 'https://ayendaman.org';
        const text = `اپلیکیشن آینده من را با کد دعوت ذیل مشاهده کنید.\nکد دعوت: ${code}\n`;
        
        if (navigator.share) {
            try {
                await navigator.share({ 
                    title: 'Ayendaman', 
                    text: text, 
                    url: appUrl 
                });
            } catch (err) {
                console.log('Share cancelled');
            }
        } else {
            const copyText = `${text}\n${appUrl}`;
            navigator.clipboard.writeText(copyText);
            this.notify('لینک و متن دعوت کاپی شد', 'success');
        }
    },
    async registerNextGrade() {
      if (!this.userInfo.grade_id) {
         this.notify('اطلاعات تحصیلی یافت نشد', 'error');
         return;
      }

      this.registeringNextGrade = true;
      try {
        const userId = localStorage.getItem('user_id');
        const formData = createFormData({
           user_id: userId,
           grade_id: this.userInfo.grade_id
        });

        const response = await apiClient.post('/register_next_grade', formData);

        if (response.data.status === 'ok') {
           this.notify(response.data.message, 'success');
           this.showNextGradeModal = false;
        } else {
           this.notify(response.data.message || this.t('error_submit'), 'error');
        }

      } catch (error) {
        console.error(error);
        this.notify(this.t('connection_error'), 'error');
      } finally {
        this.registeringNextGrade = false;
      }
    }
  }
}
</script>

<style scoped>
.profile {
  border: 3px solid white;
  width: 6rem;
  height: 6rem;
  object-fit: cover;
}
.cursor-pointer {
  cursor: pointer;
}
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal_content {
  background-color: white;
  width: 85%;
  max-width: 25rem;
  border-radius: 1.5rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: fadeIn 0.3s ease-out;
}
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
.lang_button {
  width: 100%;
  padding: 1rem;
  border-radius: 1rem;
  border: 1px solid #ddd;
  background-color: #f8f8f8;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.lang_button:hover {
  background-color: #eee;
  transform: translateY(-2px);
}
.lang_button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.text-truncate {
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis; 
}
.pb-8 {
    padding-bottom: 8rem !important;
}
.bg_red {
    background: #FF0000 !important;
    box-shadow: 0 5px 15px rgba(255, 0, 0, 0.2) !important;
    color: white;
}
.bg_gray {
    background: #9e9e9e !important;
    box-shadow: none !important;
    color: white;
}
</style>